export const getQueryParamValue = (url, paramName) => {
  const paramRegex = new RegExp(`[?&]${paramName}=([^&]*)`);
  const match = url.match(paramRegex);
  return match ? decodeURIComponent(match[1]) : null;
};

export const isTokenStillValid = (token) => {
  const tokenData = jwtDecode(token);
  const expDateMilliseconds = tokenData.payload.exp * 1000;
  const now = Date.now();
  const expDate = new Date(expDateMilliseconds).getTime();
  const valid = now < expDate;
  return valid;
};

export const jwtDecode = (t) => {
  let token = {};
  token.raw = t;
  token.header = JSON.parse(window.atob(t.split(".")[0]));
  token.payload = JSON.parse(window.atob(t.split(".")[1]));
  return token;
};
